import Vue from "vue";
import Vuex from "vuex";
import global from './modules/global';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    global
  },
  //   strict: true, // 严格模式，只能通过 mutation 来更改状态
});


// WEBPACK FOOTER //
// ./src/store/index.js